"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = exports.COLOR_VARIANTS = void 0;
const config_1 = require("../common/config");
const borders_1 = __importDefault(require("./borders"));
const colors_1 = __importDefault(require("./colors"));
const spacings_1 = __importDefault(require("./spacings"));
const texts_1 = __importDefault(require("./texts"));
const Suntheme = (config) => {
    (0, config_1.mergeConfig)(config);
    return {
        borders: borders_1.default,
        colors: colors_1.default,
        spacings: (0, spacings_1.default)(),
        texts: (0, texts_1.default)(),
    };
};
var colors_2 = require("./colors");
Object.defineProperty(exports, "COLOR_VARIANTS", { enumerable: true, get: function () { return colors_2.COLOR_VARIANTS; } });
Object.defineProperty(exports, "COLORS", { enumerable: true, get: function () { return colors_2.COLORS; } });
exports.default = Suntheme;
